var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * Function to get the reducer according to the prefix
 * @param prefix string that contains the prefix
 * @param subItemKey The the key to get the reducer for child objects
 *
 * @return array of string with the names of the reducers
 */
export function getPrefixedReducer(prefix, subItemKey) {
    var rowNameReducer = function (current, value, index) {
        var lineName = prefix + "[" + index + "]";
        var newCurrent = __spread(current, [lineName]);
        if (subItemKey !== undefined) {
            var subItems = value[subItemKey];
            if (subItems !== undefined && subItems.length > 0) {
                newCurrent = subItems.reduce(getPrefixedReducer(lineName + "." + subItemKey, subItemKey), newCurrent);
            }
        }
        return newCurrent;
    };
    return rowNameReducer;
}
//# sourceMappingURL=getPrefixedReducer.js.map